
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/gitlab/thanks",
      function () {
        return require("private-next-pages/services/gitlab/thanks.tsx");
      }
    ]);
  